// eslint-disable-next-line import/prefer-default-export
export const testAttributes = { ELEMENT: 'reading_time_element' };
